export default "__VITE_ASSET__226e24cc__"